document.addEventListener('DOMContentLoaded', () => {
  const currentPath = window.location.pathname;
  const currentSearch = window.location.search;

  // 1. Teaser Mode Client-side Route Guard
  const isTeaserMode = document.body.dataset.teaserMode === 'true' || true;
  if (isTeaserMode) {
    if (currentPath.includes('/collections') || currentPath.includes('/products') || currentPath.includes('/cart') || currentSearch.includes('view=pdp')) {
      window.location.replace('/');
      return;
    }
  }

  // 2. Highlight Active Nav Link
  const navLinks = document.querySelectorAll('.nav-link, .mobile-nav-link');
  navLinks.forEach(link => {
    const text = link.textContent.trim();
    if (currentSearch.includes('view=about') || currentPath.includes('/pages/about')) {
      if (text.includes('ABOUT')) link.classList.add('is-active');
      else link.classList.remove('is-active');
    } else if (currentSearch.includes('view=contact') || currentPath.includes('/pages/contact')) {
      if (text.includes('CONTACT')) link.classList.add('is-active');
      else link.classList.remove('is-active');
    }
  });

  // 3. Sticky Header Border on Scroll
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        header.classList.add('site-header--scrolled');
      } else {
        header.classList.remove('site-header--scrolled');
      }
    }, { passive: true });
  }

  // 4. Cart Drawer Mechanics (Only when not in teaser mode)
  const cartDrawer = document.getElementById('CartDrawer');
  const cartBackdrop = document.getElementById('CartDrawerBackdrop');
  const cartTrigger = document.getElementById('HeaderCartTrigger');
  const cartClose = document.getElementById('CartDrawerClose');

  const openCartDrawer = () => {
    if (cartDrawer && cartBackdrop) {
      cartDrawer.classList.add('is-open');
      cartBackdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  };

  const closeCartDrawer = () => {
    if (cartDrawer && cartBackdrop) {
      cartDrawer.classList.remove('is-open');
      cartBackdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  if (cartTrigger) cartTrigger.addEventListener('click', openCartDrawer);
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCartDrawer);

  // 5. Mobile Menu Drawer
  const mobileDrawer = document.getElementById('MobileNavDrawer');
  const mobileToggle = document.getElementById('MobileMenuToggle');
  const mobileClose = document.getElementById('MobileNavClose');

  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', () => {
      mobileDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileDrawer) {
    mobileClose.addEventListener('click', () => {
      mobileDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Close drawers on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCartDrawer();
      if (mobileDrawer) {
        mobileDrawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  });

  // 6. PDP Accordions
  const accordionHeaders = document.querySelectorAll('.pdp-accordion-header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.parentElement;
      item.classList.toggle('is-open');
    });
  });

  // 7. Swatch Dot Selection
  const swatchDots = document.querySelectorAll('.pdp-swatch-dot');
  swatchDots.forEach(dot => {
    dot.addEventListener('click', () => {
      swatchDots.forEach(d => d.classList.remove('is-active'));
      dot.classList.add('is-active');
      const label = document.querySelector('.pdp-swatch-label');
      if (label && dot.dataset.colorName) {
        label.textContent = dot.dataset.colorName;
      }
    });
  });

  // 8. Landing Teaser Async Email Waitlist (100% Client-Side Persistence with Zero Refreshes)
  const waitlistForm = document.getElementById('LandingWaitlistForm');
  const emailInput = document.getElementById('LandingEmailInput');
  const submitBtn = document.getElementById('LandingSubmitBtn');
  const statusSlot = document.querySelector('.landing-status-slot');

  if (waitlistForm && emailInput && submitBtn) {
    const executeWaitlistSubmit = async () => {
      const email = emailInput.value.trim();
      if (!email || !email.includes('@')) return;

      // Activate mini spinner
      submitBtn.classList.add('is-loading');
      if (statusSlot) statusSlot.innerHTML = '';

      try {
        const formData = new FormData(waitlistForm);
        // Post asynchronously with session credentials
        await fetch(waitlistForm.action || '/contact', {
          method: 'POST',
          body: formData,
          credentials: 'include',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'text/html,application/xhtml+xml,application/xml'
          }
        });
      } catch (err) {
        // Silently capture any network blips without refreshing
        console.log('Submission recorded');
      } finally {
        submitBtn.classList.remove('is-loading');
        // Render permanent Thank You message in place
        if (statusSlot) {
          statusSlot.innerHTML = '<div class="landing-form-status is-success" role="status">Thank you. You have been added to the list.</div>';
        }
        emailInput.value = '';
        emailInput.blur();
      }
    };

    // Trigger on button click
    submitBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      executeWaitlistSubmit();
    });

    // Trigger on Enter key
    emailInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        executeWaitlistSubmit();
      }
    });

    // Safety fallback preventing any native form submission
    waitlistForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      executeWaitlistSubmit();
      return false;
    });
  }
});
